import {
  PURCHASEHISTORY_LOADING,
  GET_PURCHASEHISTORY,
  GET_PURCHASEHISTORY_SUCCESS,
  GET_PURCHASEHISTORY_FAIL,
  ADD_PURCHASEHISTORY_SUCCESS,
  ADD_PURCHASEHISTORY_FAIL,
  DELETE_PURCHASEHISTORY_SUCCESS,
  DELETE_PURCHASEHISTORY_FAIL,
  UPDATE_PURCHASEHISTORY_SUCCESS,
  UPDATE_PURCHASEHISTORY_FAIL,
  PURCHASEHISTORY_RESET
} from "./actionType";

const INIT_STATE = {
  purchaseHistories: [],
  error: {},
};

const PurchaseHistory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PURCHASEHISTORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PURCHASEHISTORY:
          return {
            ...state,
            purchaseHistories: action.payload.data,
            isPurchaseHistoryCreated: false,
            isPurchaseHistorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PURCHASEHISTORY_FAIL:
      switch (action.payload.actionType) {
        case GET_PURCHASEHISTORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPurchaseHistoryCreated: false,
            isPurchaseHistorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PURCHASEHISTORY: {
      return {
        ...state,
        isPurchaseHistoryCreated: false,
        loading: true,
      };
    }

    case PURCHASEHISTORY_LOADING: {
      return {
        ...state,
        isPurchaseHistoryCreated: false,
        loading: true,
      };
    }

    case ADD_PURCHASEHISTORY_SUCCESS:
      return {
        ...state,
        isPurchaseHistoryCreated: true,
        loading: false,
        purchaseHistories: [action.payload.data, ...state.purchaseHistories],
      };

    case ADD_PURCHASEHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PURCHASEHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isPurchaseHistoryCreated: true,
        purchaseHistories: state.purchaseHistories.filter(
          purchaseHistory => purchaseHistory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PURCHASEHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PURCHASEHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isPurchaseHistoryCreated: true,
        purchaseHistories: state.purchaseHistories.map(purchaseHistory =>
          purchaseHistory.id.toString() === action.payload.data.id.toString() ? { ...purchaseHistory, ...action.payload.data } : purchaseHistory
        ),
      };

    case UPDATE_PURCHASEHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PURCHASEHISTORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PurchaseHistory;